import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/website-build/website-build/src/Layout.tsx";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Title = makeShortcode("Title");
const Section = makeShortcode("Section");
const Image = makeShortcode("Image");
const SubTitle = makeShortcode("SubTitle");
const Link = makeShortcode("Link");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Title mdxType="Title">Building Energy Efficiency</Title>
    <Section mdxType="Section">
  <Image src={'https://sjyurbanlab.github.io/website-assets/research-theme/building-energy-efficiency/building-energy-efficiency.png'} alt={'building energy efficiency'} size={'medium'} center mdxType="Image" />
    </Section>
    <Section mdxType="Section">
      <SubTitle mdxType="SubTitle">Reference</SubTitle>
      <p><strong parentName="p">{`Song J`}</strong>{`, Huang X, Shi D, Lin WE, Fan S, Linden PF (2021). `}<Link href={'https://doi.org/10.1016/j.buildenv.2021.107722'} mdxType="Link">{`Natural ventilation in London: Towards energy-efficient and healthy buildings, `}<em parentName="p">{`Building and Environment`}</em>{`, 195, 107722.`}</Link></p>
      <p><strong parentName="p">{`Song J`}</strong>{`, Fan S, Lin W, Mottet L, Woodward H, Davies Wykes M, Arcucci R, Xiao D, Debay J-E, ApSimon H, Aristodemou E, Birch D, Carpentieri M, Fang F, Herzog M, Hunt GR, Jones RL, Pain C, Pavlidis D, Robins AG, Short CA, Linden PF (2018), `}<Link href={'https://doi.org/10.1080/09613218.2018.1468158'} mdxType="Link">{`Natural ventilation in cities: the implications of fluid mechanics. `}<em parentName="p">{`Building Research & Information`}</em>{`, 46(8), 809-828.`}</Link></p>
      <p>{`Short CA, `}<strong parentName="p">{`Song J`}</strong>{`, Mottet L, Chen S, Wu J, Ge J (2018). `}<Link href={'https://doi.org/10.1080/09613218.2018.1489465'} mdxType="Link">{`Challenges in the low carbon adaptation of towers in China. `}<em parentName="p">{`Building Research & Information`}</em>{`, 46(8), 899-930.`}</Link></p>
      <p>{`Mottet L, `}<strong parentName="p">{`Song J`}</strong>{`, Short CA, Chen S, Wu J, Yu W, Xiong J, Zhang Q, Ge J, Liu M, Yao R, Li B (2020). `}<Link href={'https://doi.org/10.1016/j.enbuild.2020.110181'} mdxType="Link">{`The hot summer-cold winter region in China: Challenges in the low carbon adaptation of residential slab buildings to enhance comfort. `}<em parentName="p">{`Energy and Buildings`}</em>{`, 223, 110181.`}</Link></p>
    </Section>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      